import styled from 'styled-components'
import empresacnpj from '../assets/empresacnpj.jpg'
import pessoacpf from '../assets/pessoacpf.jpg'
export  const MainContainer = styled.div`
  width:100vw;
  height:100vh;
  display:flex;
  flex-direction:column;
  justify-content:center;
  align-items:flex-start;
  padding:80px;
    background-image:url(${(props) => props.type === 'cnpj' ? empresacnpj : pessoacpf});
    background-size:cover;
`